import { AuthenticateTokenInput, AuthResponse } from '../../lib/types/models/auth/login'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function authenticateToken(data: AuthenticateTokenInput) {
  return restApiClient
    .url(constructApiUrl(API.auth['authenticate-token'].url, null))
    .post<AuthResponse, AuthenticateTokenInput>(data)
}
